import {SelectableListItem as BaseSelectableListItem} from '../../control';

export const SelectableListItem = BaseSelectableListItem;
export default SelectableListItem;
